import React from 'react';
import ReactDOM from 'react-dom';
import {createRoot}  from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import {ToastContainer, toast } from 'react-toastify';


/*ReactDOM.render(
    
<React.StrictMode>
<BrowserRouter basename="/crm">
  <App />
</BrowserRouter>
</React.StrictMode>

,document.getElementById('root'));*/

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <BrowserRouter basename="/crm">
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      />
{/* Same as */}
<ToastContainer />
  <App />
</BrowserRouter>
  </React.StrictMode>
);

//serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
